import React from 'react';
import { Facebook, Instagram } from 'lucide-react';
import { restaurantInfo } from '../mock';

const TikTokIcon = ({ className }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round" 
    className={className}
  >
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  </svg>
);

const Header = ({ onReservationClick }) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-md border-b border-border/40 transition-all duration-300">
      <div className="container mx-auto px-6 py-5 flex justify-between items-center">
        {/* Logo Section */}
        <div className="flex flex-col items-center justify-center">
          <img 
            src="https://customer-assets.emergentagent.com/job_2e08abfd-9d61-4b02-9272-bb8dc030b0a2/artifacts/jzwyfc9h_log%EF%BD%A2_SZLOGENNEL_K%E5%85%92EPESFELBONTAS.jpg" 
            alt="aKonyhád! Logo" 
            className="h-12 w-auto object-contain mix-blend-multiply"
          />
        </div>

        <div className="flex items-center gap-8">
          <div className="hidden md:flex flex-col items-end gap-1">
            <a href={`tel:${restaurantInfo.phone}`} className="text-[10px] uppercase tracking-widest text-muted-foreground hover:text-foreground transition-colors leading-none">
              {restaurantInfo.phone}
            </a>
            <a href="tel:06705858222" className="text-[10px] uppercase tracking-widest text-muted-foreground hover:text-foreground transition-colors leading-none">
              06 70 585 8222
            </a>
          </div>
          <div className="h-4 w-px bg-border hidden md:block"></div>
          <div className="flex items-center gap-4">
            <a 
              href={restaurantInfo.facebook} 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              <Facebook className="w-4 h-4" />
            </a>
            <a 
              href="https://www.instagram.com/akonyhad/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              <Instagram className="w-4 h-4" />
            </a>
            <a 
              href="https://www.tiktok.com/@akonyhd?_r=1&_t=ZN-97VMglqixdu" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              <TikTokIcon className="w-4 h-4" />
            </a>
          </div>
          <button 
            onClick={onReservationClick}
            className="md:hidden text-xs uppercase tracking-widest border border-foreground px-4 py-2 hover:bg-foreground hover:text-background transition-colors"
          >
            Foglalás
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
